module.exports = __webpack_public_path__ + "static/img/tianjinpu.4dbbeb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tianjinpu.png
// module id = 8nXf
// module chunks = 1